module.exports = __webpack_public_path__ + "static/media/locationInput.e3435111.svg";